import { createSvgIcon } from '@material-ui/core';

export const WittyIcon = createSvgIcon(
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.852 0.601235C21.9086 0.466255 22.1216 0.466255 22.1783 0.601235C22.2959 0.881691 22.4628 1.22634 22.6297 1.39154C22.7976 1.55776 23.1319 1.72399 23.4007 1.84058C23.5331 1.89805 23.5331 2.10183 23.4007 2.15928C23.1319 2.27587 22.7976 2.44208 22.6297 2.60831C22.4628 2.77351 22.2959 3.11815 22.1783 3.39861C22.1216 3.53359 21.9086 3.53359 21.852 3.39861C21.7343 3.11815 21.5674 2.77351 21.4005 2.60831C21.2336 2.4431 20.8855 2.2779 20.6022 2.16143C20.4658 2.10537 20.4658 1.8945 20.6022 1.83843C20.8855 1.72195 21.2336 1.55674 21.4005 1.39154C21.5674 1.22634 21.7343 0.881691 21.852 0.601235Z"
      fill="url(#paint0_linear_125_14779)"
    />
    <path
      d="M16.6964 0.611533C16.6274 0.462822 16.3852 0.462822 16.3163 0.611533C16.2379 0.780364 16.1435 0.951723 16.049 1.04556C15.9546 1.1394 15.7821 1.23324 15.6122 1.31108C15.4626 1.37963 15.4626 1.62028 15.6122 1.68883C15.7822 1.76666 15.9546 1.8605 16.049 1.95433C16.1435 2.04817 16.2379 2.21953 16.3163 2.38836C16.3852 2.53707 16.6274 2.53707 16.6964 2.38836C16.7747 2.21953 16.8692 2.04817 16.9636 1.95433C17.0593 1.85925 17.2276 1.76416 17.3911 1.68574C17.5364 1.61598 17.5364 1.38393 17.3911 1.31417C17.2277 1.23574 17.0593 1.14065 16.9636 1.04556C16.8692 0.951723 16.7747 0.780364 16.6964 0.611533Z"
      fill="url(#paint1_linear_125_14779)"
    />
    <path
      d="M19.181 2.59282C19.1336 2.46948 18.9455 2.46948 18.8981 2.59282C18.6976 3.1145 18.3123 4.02173 17.9269 4.40204C17.5415 4.78237 16.6222 5.1627 16.0936 5.36058C15.9687 5.40736 15.9687 5.59305 16.0936 5.63983C16.6222 5.83766 17.5415 6.21793 17.9269 6.59826C18.3123 6.97859 18.6976 7.88585 18.8981 8.40751C18.9455 8.53083 19.1336 8.53083 19.181 8.40751C19.3815 7.88585 19.7669 6.97859 20.1522 6.59826C20.5386 6.217 21.4116 5.83568 21.909 5.6383C22.0304 5.59009 22.0304 5.41027 21.909 5.36206C21.4116 5.16468 20.5386 4.78336 20.1522 4.40204C19.7669 4.02173 19.3815 3.1145 19.181 2.59282Z"
      fill="url(#paint2_linear_125_14779)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.5329 3.45861C15.1722 2.76544 13.6318 2.3746 12 2.3746C6.47715 2.3746 2 6.85179 2 12.3747C2 17.8976 6.47715 22.3748 12 22.3748C17.5228 22.3748 22 17.8976 22 12.3747C22 10.7871 21.63 9.28587 20.9716 7.95259C20.327 8.83066 19.7225 10.2665 19.3835 11.149C19.289 11.3948 18.9139 11.3948 18.8194 11.149C18.4198 10.1089 17.6515 8.30008 16.8832 7.5418C16.115 6.78352 14.2823 6.02535 13.2285 5.63094C12.9794 5.53768 12.9794 5.16746 13.2285 5.07419C14.1451 4.73106 15.6508 4.11275 16.5329 3.45861ZM17.8594 12.3747C17.8594 15.6108 15.236 18.2341 12 18.2341C8.76399 18.2341 6.14064 15.6108 6.14064 12.3747C6.14064 9.13857 8.76399 6.51524 12 6.51524C15.236 6.51524 17.8594 9.13857 17.8594 12.3747Z"
      fill="url(#paint3_linear_125_14779)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_125_14779"
        x1="4.25"
        y1="2.75"
        x2="21.75"
        y2="21.25"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EE72D3" />
        <stop offset="1" stopColor="#7C4DFF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_125_14779"
        x1="4.25"
        y1="2.75"
        x2="21.75"
        y2="21.25"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EE72D3" />
        <stop offset="1" stopColor="#7C4DFF" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_125_14779"
        x1="4.25"
        y1="2.75"
        x2="21.75"
        y2="21.25"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EE72D3" />
        <stop offset="1" stopColor="#7C4DFF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_125_14779"
        x1="4.25"
        y1="2.75"
        x2="21.75"
        y2="21.25"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EE72D3" />
        <stop offset="1" stopColor="#7C4DFF" />
      </linearGradient>
    </defs>
  </svg>,
  'WittyIcon',
);
